import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const manageBlockListPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'block_list.manage');
